// Layout.js
import React from 'react';
import { ResponsiveFlex, VFlex } from '../../Flex';
import { store } from '../../../mobx/store';

const DayKarKalLayout = ({ children, style, className }) => {
  return (
    <VFlex
      className={className}
      style={{
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: 'black',
        alignItems: 'center',
        color: 'white',
        ...style,
      }}
    >
      <img
        style={{
          width: 'auto',
          height: store.isDesktop ? '8vh' : '6vh',
          opacity: 1,
          marginTop: store.isDesktop ? 70 : 30,
          marginBottom: store.isDesktop ? 20 : 15,
          maxWidth: '90%',
        }}
        src="/images/dkk/company_logo.svg"
        alt="day karkal"
      />
      {children}
      <div style={{flex: 1}} />
      <VFlex
        style={{
          textAlign: 'center',
          letterSpacing: '0.03em',
          lineHeight: store.isDesktop ? '32px' : 1.4,
          margin: store.isDesktop ? 50 : 20,
          fontSize: store.isDesktop ? 18 : 12,
          padding: store.isDesktop ? 0 : '0 20px',
        }}
      >
        <div>
          地址：尖沙咀漢口道15號漢口中心G17舖
        </div>
        <div>WhatsApp: +852 6224 4788</div>
        <div>營業時間：星期一至日 11am - 7pm</div>
      </VFlex>
      <ResponsiveFlex
        style={{
          gap: store.isDesktop ? 30 : 20,
          marginBottom: store.isDesktop ? 200 : 50,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <VFlex style={{gap: 8, alignItems: 'center'}}>
          <img
            style={{
              width: store.isDesktop ? 200 : 120,
              height: store.isDesktop ? 200 : 120,
            }}
            src="/images/dkk/wechat-qrcode.png"
            alt=""
          />
          <div style={{fontSize: store.isDesktop ? 'inherit' : 12}}>
            ID: daykarkal
          </div>
        </VFlex>
        <VFlex style={{gap: 8, alignItems: 'center'}}>
          <img
            style={{
              width: store.isDesktop ? 200 : 120,
              height: store.isDesktop ? 200 : 120,
            }}
            src="/images/dkk/whatsapp-qrcode.png"
            alt=""
          />
          <div style={{fontSize: store.isDesktop ? 'inherit' : 12}}>
            +852 6224 4788
          </div>
        </VFlex>
      </ResponsiveFlex>
    </VFlex>
  );
};

export default DayKarKalLayout;
